import React from 'react';

import { EuiLoadingContent } from '../../../../src/components/loading';

export default () => (
  <div>
    <EuiLoadingContent lines={3} />
  </div>
);
